import React from 'react';
import { motion } from 'framer-motion';
export function FutureVisionSection() {
  return <section className="py-32 bg-secondary flex items-center justify-center" data-id="element-78">
      <div className="max-w-2xl mx-auto px-6 text-center" data-id="element-79">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="space-y-8" data-id="element-80">
          <p className="text-xl text-gray-400 font-light" data-id="element-81">Imaginá esto:</p>

          <p className="text-2xl md:text-3xl text-white font-medium leading-relaxed" data-id="element-82">
            Conocés a alguien. No dudás. No calculás. Sabés exactamente qué
            hacer y cuándo.
          </p>

          <p className="text-2xl md:text-3xl text-white font-medium leading-relaxed" data-id="element-83">
            No porque tengas un guión. Sino porque entendés cómo funciona la
            atracción.
          </p>

          <p className="text-2xl md:text-3xl text-gold font-medium leading-relaxed pt-4" data-id="element-84">
            Esa seguridad no se compra. Se construye. Y empieza con un sistema.
          </p>
        </motion.div>
      </div>
    </section>;
}